import { render, staticRenderFns } from "./LocationServicePublicPortalInfo.vue?vue&type=template&id=4a15f70e&scoped=true"
import script from "./LocationServicePublicPortalInfo.vue?vue&type=script&lang=js"
export * from "./LocationServicePublicPortalInfo.vue?vue&type=script&lang=js"
import style0 from "./LocationServicePublicPortalInfo.vue?vue&type=style&index=0&id=4a15f70e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15f70e",
  null
  
)

export default component.exports